export const print = () => {
	window.print();
};
